import { inject, Injectable } from '@angular/core';
import { IDialogData } from '../../components/dialogs/dialog';
import { UserOnboardingDialogComponent } from '../../components/dialogs/user-onboarding-dialog/user-onboarding-dialog.component';
import { DialogService } from '../support/dialog/dialog.service';

@Injectable({
  providedIn: 'root',
})
export class OnboardingDialogService {
  private readonly dialogService: DialogService = inject(DialogService);

  public open(): void {
    this.dialogService.openDialog<IDialogData>(UserOnboardingDialogComponent, {
      headline: '',
      width: '600px',
    });
  }
}
